var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBarOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.203 10.852h-17.3c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h17.3c.5 0 .9.4.9.9s-.4.9-.9.9zM14.403 17.852h-11.5c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h11.5c.5 0 .9.4.9.9s-.4.9-.9.9z",
    fill: "#202020"
  })));
}
export default SvgSideBarOpen;